module.exports = __webpack_public_path__ + "img/pirate-fountain--icon--gray.a0c888a1.svg";